export default __webpack_public_path__ + "static/media/invite-icon.a7e200ba.svg";